import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";

import imcoming_call from '../../../../images/manage_calls/incoming_call.ico';
import outgoing_call from '../../../../images/manage_calls/outgoing_call.ico';
import dialed_call from '../../../../images/manage_calls/dialed_call.ico';
import missed_call from '../../../../images/manage_calls/missed_call.ico';
import rejected_call from '../../../../images/manage_calls/reject_call.ico';

import Location from '../../../modal/Lead_Management/Manage_Call/Location';

import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';

const Manage_Calls = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [yeardisplay, setyeardisp] = useState(new Date());

    const [datas, setData] = useState([]);
    const [responses, setresp] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const [loading, setLoading] = useState(false);
    
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const [incommingCalls, setIncommingCalls] = useState(0);
    const [Outgoingcalls, setOutgoingCalls] = useState(0);
    const [DailedCalls, setDailedCalls] = useState(0);
    const [missedCalls, setMissedCalls] = useState(0);
    const [rejectedCalls, setRejectedCalls] = useState(0);

    const [outgoingCallRate, setOutgoingRate] = useState(0.00);
    const [missedCallRate, setmissedRate] = useState(0.00);
    
    // page table data fetch
    const fetchData = () => {
        setLoading(true);
        const params = {
            month: yeardisplay.getMonth() + 1,
            year: yeardisplay.getFullYear(),
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/get_all_calls`, { params: params })
            .then(response => {
                setData(response.data.data);
                setresp(response.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);

                setIncommingCalls(response.data.incoming);
                setOutgoingCalls(response.data.outgoing);
                setDailedCalls(response.data.dialed);
                setMissedCalls(response.data.missed);
                setRejectedCalls(response.data.rejected);

                setOutgoingRate(response.data.outgoing_call_rate);
                setmissedRate(response.data.missed_call_ratio);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage, yeardisplay]);


    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);


    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            const ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12;
            if (hour === 0) hour = 12;

            // Pad minute and second if needed
            const paddedMinute = minute.padStart(2, '0');
            const paddedSecond = second.padStart(2, '0');

            return `${hour}:${paddedMinute}:${paddedSecond} ${ampm}`;
        } else {
            return '';
        }
    }


    const renderCallStatusContent = (status) => {
        switch (status) {
            case 0:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={outgoing_call} className="border rounded px-1 py-0">
                            <img src={outgoing_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 1:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={imcoming_call} className="border rounded px-1 py-0">
                            <img src={imcoming_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 2:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={missed_call} className="border rounded px-1 py-0">
                            <img src={missed_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 3:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={rejected_call} className="border rounded px-1 py-0">
                            <img src={rejected_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 4:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={dialed_call} className="border rounded px-1 py-0">
                            <img src={dialed_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            default:
                return null;
        }
    };

    const renderCallStatusbadge = (status) => {
        switch (status) {
            case 0:
                return (
                   <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#ffbc67' }}>Outgoing Call</div>
                );
            case 1:
                return (
                    <div className="badge cess text-black rounded fw-bold fs-8" style={{ backgroundColor: '#ebb5a9' }}>Incoming Call</div>
                );
            case 2:
                return (
                   <div className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#4c84e1' }}>Missed Call</div>
                );
            case 3:
                return (
                    <div className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#ff0028' }}>Rejected Call</div>
                );
            case 4:
                return (
                    <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#6ac7e8 ' }}>Dailed Call</div>
                );
            default:
                return null;
        }
    };

    const monthShort = yeardisplay.toLocaleString('en-US', { month: 'short' }); // e.g. "Apr"

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [latitude, setlatitude] = useState('');
    const [longitude, setlongitude] = useState('');


    const handleModalLocation = (lat, long) => {
        setlatitude(lat);
        setlongitude(long);
        setModalType("Location");
        setOpen(true);
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Call Log</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Monitoring Tools</li>
                    </ol>
                </div>

                <div className="d-flex align-items-center justify-content-end mb-1">
                    <div className="w-60 mb-1 col-lg-8">
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)}  maxDate={new Date()} onChange={(date) => setyeardisp(new Date(date))} />
                            <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
                        </div>
                    </div>
                </div>

                {open && modalType === "Location" && (
                    <Location show={open} onClose={() => setOpen(false)} lat={latitude} long={longitude} />
                )}
            </div>

            <LoadingComponent loading={loading} />

            <Row className='mb-4'>
                
                <div className="d-flex align-items-center justify-content-lg-between justify-content-center flex-wrap gap-2">
                    <div className="d-flex align-items-center justify-content-center flex-wrap gap-2 mb-0">
                        <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Incoming Calls">
                            <div className="fw-semibold fs-6 text-black text-center">Incoming Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                            <div>
                                <img src={imcoming_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-block mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Incomming Calls</span> </Tooltip>}>
                                <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#ebb5a9' }}>{incommingCalls}</div>
                                </OverlayTrigger>
                            </div>
                        </div>    
                        <div className="text-center border border-2 p-2 mb-2">
                            <div className="fw-semibold fs-6 text-black text-center">Outgoing Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                            <div>
                                <img src={outgoing_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-flex align-items-center justify-content-center mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Outgoing Calls</span> </Tooltip>}>
                                <label className='badge text-black rounded fw-bold fs-8' style={{ backgroundColor: '#ffbc67' }}>{Outgoingcalls}</label>
                                </OverlayTrigger>
                                <label className="text-black fs-6 fw-bold ms-1 me-1">/</label>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Outgoing Call Rate</span> </Tooltip>}>
                                <label className='badge text-black rounded fw-bold fs-8' style={{ backgroundColor: '#ffbc67' }}>{outgoingCallRate}</label>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Dialed Calls">
                            <div className="fw-semibold fs-6 text-black text-center">Dialed Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                            <div>
                                <img src={dialed_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-block mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Dialed Calls</span> </Tooltip>}>
                                <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#6ac7e8 ' }}>{DailedCalls}</div>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="text-center border border-2 p-2 mb-2">
                            <div className="fw-semibold fs-6 text-black text-center">Missed Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                            <div>
                                <img src={missed_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-flex align-items-center justify-content-center mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Missed Calls</span> </Tooltip>}>
                                <div  className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#4c84e1' }}>{missedCalls}</div>
                                </OverlayTrigger>
                                <label className="text-black fs-6 fw-bold ms-1 me-1">/</label>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Missed Call Ratio</span> </Tooltip>}>
                                <div  className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#4c84e1' }}>{missedCallRate}</div>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Rejected Calls">
                            <div className="fw-semibold fs-6 text-black text-center">Rejected Calls</div>
                            <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                            <div>
                                <img src={rejected_call} className='w-45px h-45px' alt="Incomming Call" />
                            </div>
                            <div className="d-block mt-2">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ <Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Rejected Calls</span> </Tooltip>}>
                                <div  className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#ff0028' }}>{rejectedCalls}</div>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>

                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Row>
                            <Col xl={12}>
                                <div className="table-container">

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                className="form-select d-inline w-auto"
                                                style={{  fontSize: '0.85rem', height: '30px' }}
                                                value={perPage}
                                                onChange={(e) => {
                                                    setPerPage(Number(e.target.value));
                                                    setPage(1); // Reset to first page
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <input
                                                type="text"
                                                style={{  fontSize: '0.85rem', height: '40px' }}
                                                placeholder="Search..."
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setPage(1); // Reset page on new search
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <table style={{ borderBottom: '2px solid #ddd' }} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                                <th className='min-w-90px'>Staff</th>
                                                <th className='min-w-100px'>Communicator</th>
                                                <th className='min-w-100px'>Call Date</th>
                                                <th className='min-w-50px'>Start Time</th>
                                                <th className='min-w-50px'>End Time</th>
                                                <th className='min-w-50px'>Duration</th>
                                                <th className='min-w-50px text-center'>Status</th>
                                                <th className='min-w-20px text-center'>Location</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                                            {datas.length === 0 && hasFetched ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center text-muted py-2">
                                                        No data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {datas.map((data, index) => (
                                                        <tr key={data.sno}>
                                                            <td>
                                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                                    {renderCallStatusContent(data.call_status)}
                                                                    <div className='mb-0'>
                                                                        <label className='text-black font-w400 fs-7'>{data.staff_name}</label>
                                                                        <div className="d-block">
                                                                            <div className="fs-8 font-w600 text-dark">{data.staff_phone_no}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.customer_name ? data.customer_name : 'Unknown'}</div>
                                                                <div className="d-block position-relative" style={{ maxWidth: '75%' }}>
                                                                    <div className="d-flex align-items-center">
                                                                        <div className='text-dark font-w600 fs-8 text-wrap mw-75'>{data.customer_phone_no}</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='text-black font-w400 fs-7  mw-75'>{formatDate(data.call_start_date)}</div>
                                                            </td>
                                                            <td>
                                                                <div className='text-black font-w400 fs-7  mw-75'>{convert24to12(data.call_start_time)}</div>
                                                            </td>
                                                            <td>
                                                                <div className='text-black font-w400 fs-7  mw-75'>{convert24to12(data.call_end_time)}</div>
                                                            </td>
                                                            <td>
                                                                <div className='text-black font-w400 fs-7 mw-75'>{data.call_duration}</div>
                                                            </td>
                                                            <td className='text-center'>
                                                                {renderCallStatusbadge(data.call_status)}
                                                            </td>
                                                            <td>
                                                                <div className="text-center">
                                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={ 
                                                                            <Tooltip className="toltip-popover">
                                                                                <span className="fs-8 text-white fw-semibold">Location</span>
                                                                            </Tooltip>
                                                                        }>
                                                                            <Button onClick={()=> handleModalLocation(data.latitude, data.longitude)} variant="primary tp-btn-light px-2 py-1 me-1" >
                                                                                <span>
                                                                                    <i class="fa-solid fa-map-location-dot fs-4 mt-1"></i>
                                                                                </span>
                                                                            </Button>
                                                                        </OverlayTrigger>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            )}

                                        </tbody>
                                    </table>
                                    
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            {datas.length > 0 ? (
                                                <span className="text-muted">
                                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                </span>
                                            ):(
                                                <span className="text-muted">
                                                    Showing 0 to 0 of 0 entries
                                                </span>
                                            )}
                                        </div>

                                        {/* Bottom right: Pagination */}
                                        {/* <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                </li>
                                                {[...Array(totalPages)].map((_, i) => (
                                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                </li>
                                                ))}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                </li>
                                            </ul>
                                        </nav> */}

                                        <nav>
                                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                {/* Previous Button */}
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                    Previous
                                                </button>
                                                </li>

                                                {/* First Page */}
                                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                    1
                                                </button>
                                                </li>

                                                {/* Left Ellipsis */}
                                                {page > 4 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Pages Around Current */}
                                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                .map(p => (
                                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                        {p}
                                                    </button>
                                                    </li>
                                                ))}

                                                {/* Right Ellipsis */}
                                                {page < totalPages - 3 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                                )}

                                                {/* Last Page */}
                                                {totalPages > 1 && (
                                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                    {totalPages}
                                                    </button>
                                                </li>
                                                )}

                                                {/* Next Button */}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                    Next
                                                </button>
                                                </li>
                                            </ul>
                                        </nav>


                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            
        </>
    )


}
export default Manage_Calls;